/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 19);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addRef__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneElement__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Component__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__h__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__render__ = __webpack_require__(12);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ref", function() { return __WEBPACK_IMPORTED_MODULE_0__addRef__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addRef", function() { return __WEBPACK_IMPORTED_MODULE_0__addRef__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "cloneElement", function() { return __WEBPACK_IMPORTED_MODULE_1__cloneElement__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Component", function() { return __WEBPACK_IMPORTED_MODULE_2__Component__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__h__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "render", function() { return __WEBPACK_IMPORTED_MODULE_4__render__["a"]; });







/***/ }),
/* 1 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(8);

var assertThisInitialized = __webpack_require__(33);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(34);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_utils_state__ = __webpack_require__(32);

var Store = {
  seed: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["b" /* writable */])(Date.now()),
  debug: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["b" /* writable */])(false),
  cell: {
    size: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])(295),
    unit: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])('mm')
  },
  wall: {
    cols: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])(4),
    rows: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])(5),
    cellsLength: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])(4)
  },
  colors: {
    length: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])(1),
    primary: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])(['#4fc6e1', '#d4dd21', '#f5821f']),
    secondary: Object(__WEBPACK_IMPORTED_MODULE_0_utils_state__["a" /* readable */])(['#f49ac2', '#67c18d', '#8a6161', '#c41330', '#004b35', '#812990'])
  }
};
window.Store = Store;
/* harmony default export */ __webpack_exports__["a"] = (Store);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = extend;
function extend(obj, nObj) {
  for (var i in nObj) {
    obj[i] = nObj[i];
  }

  return obj;
}

/***/ }),
/* 8 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(29);

var iterableToArrayLimit = __webpack_require__(30);

var nonIterableRest = __webpack_require__(31);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(h) {/* unused harmony export UNWANTED_PROPS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BASE_UNIT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_svg_parser__ = __webpack_require__(47);
/* global h */


var reqs = __webpack_require__(48);

var UNWANTED_PROPS = ['id', 'class'];
var BASE_UNIT = 64;
/* harmony default export */ __webpack_exports__["b"] = (reqs.keys().map(function (key) {
  var raw = reqs(key).default;
  return {
    raw: raw,
    filename: key.split(/(\\|\/)/g).pop(),
    parsed: Object(__WEBPACK_IMPORTED_MODULE_0_svg_parser__["a" /* parse */])(raw),
    toJsx: function toJsx(props) {
      var svg = this.parsed.children[0];
      return svg.children.map(function (el) {
        if (el.properties.class === 'st0') return;
        if (el.tagName === 'style') return;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = UNWANTED_PROPS[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var prop = _step.value;
            delete el.properties[prop];
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return h(el.tagName, Object.assign(el.properties, {
          fill: 'white',
          x: 0,
          y: 0,
          width: BASE_UNIT,
          height: BASE_UNIT
        }, props));
      });
    }
  };
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)["h"]))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Create a VNode (virtual DOM element)
function h(type, props) {
  var vn = {};
  vn.vnode = true;
  vn.type = type;
  vn.props = props || {};
  vn.children = [].concat.apply([], [].slice.call(arguments, 2)); // array & flatten

  vn.isInstance = type && type.template && typeof type.template === 'function';
  vn.isComponent = typeof type === 'function' && type.prototype && typeof type.prototype.render === 'function';
  vn.isStateless = typeof type === 'function' && !vn.isComponent;
  vn.isDom = typeof type === 'string';
  return vn;
}

h.f = function (p) {
  return p.children;
};

/* harmony default export */ __webpack_exports__["a"] = (h);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = render;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_rawRender__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_dispatch__ = __webpack_require__(28);


var SvgTagNames = new Set(['g', 'svg', 'defs']);
function render(vnode, parent, context) {
  // render
  var i = 0;
  var rendered = Object(__WEBPACK_IMPORTED_MODULE_0__utils_rawRender__["a" /* default */])(vnode, SvgTagNames.has(parent.tagName)); // dispatch callback refs

  var mockComponent = {
    _collector: rendered
  }; // for dispatch convenience

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_dispatch__["c" /* dispatchRefs */])(mockComponent); // dispatch afterRender

  Object(__WEBPACK_IMPORTED_MODULE_1__utils_dispatch__["a" /* dispatch */])(mockComponent, function (c) {
    c.afterRender && c.afterRender(c.props);
  }); // mount

  if (typeof parent === 'function') {
    var nodes = rendered.nodes.length < 2 ? rendered.nodes[0] : rendered.nodes;
    parent(nodes);
  } else if (parent) {
    for (i = 0; i < rendered.nodes.length; i++) {
      parent.appendChild(rendered.nodes[i]);
    }
  } // This conditionnal avoids calling the dispatchers twice if
  // the renders is made during before / after render


  if (!context || context.mounted) {
    // Dispatch listeners
    Object(__WEBPACK_IMPORTED_MODULE_1__utils_dispatch__["b" /* dispatchListeners */])(mockComponent); // dispatch afterMounts

    Object(__WEBPACK_IMPORTED_MODULE_1__utils_dispatch__["a" /* dispatch */])(mockComponent, function (c) {
      c.mounted = true;
      c.afterMount && c.afterMount(c.props);
    });
  } // Add items to context


  if (context && context._collector) {
    var c = context._collector;

    for (i = 0; i < rendered.components.length; i++) {
      rendered.components[i]._parent = context;
    }

    if (c.refs) c.refs = c.refs.concat(rendered.refs);
    if (c.components) c.components = c.components.concat(rendered.components);
    if (c.domEvents) c.domEvents = c.domEvents.concat(rendered.domEvents);
    if (c.storeEvents) c.storeEvents = c.storeEvents.concat(rendered.storeEvents);
  }

  mockComponent = undefined;
  return rendered;
}

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Readable; });
/* harmony export (immutable) */ __webpack_exports__["b"] = readable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__signal__ = __webpack_require__(14);







var Readable =
/*#__PURE__*/
function (_Signal) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Readable, _Signal);

  function Readable(initialValue) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Readable);

    _this = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Readable).call(this));
    _this.current = initialValue;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Readable, [{
    key: "set",
    value: function set() {
      throw new Error('Cannot set a different value for a Readable Signal. Use Writable instead');
    }
  }, {
    key: "get",
    value: function get() {
      return this.current;
    }
  }]);

  return Readable;
}(__WEBPACK_IMPORTED_MODULE_5__signal__["a" /* Signal */]);


function readable(v) {
  return new Readable(v);
}

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Signal; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);



function SignalListener(owner, fn, ctx, once) {
  this.fn = fn;
  this.ctx = ctx || null;
  this.owner = owner;
  this.once = !!once;
}

function removeNode(owner, node) {
  if (node.prev) node.prev.next = node.next;
  if (node.next) node.next.prev = node.prev;
  node.ctx = node.fn = node.owner = null;
  if (node === owner._first) owner._first = node.next;
  if (node === owner._last) owner._last = node.prev;
}

var Signal =
/*#__PURE__*/
function () {
  function Signal() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Signal);

    this._first = this._last = null;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Signal, [{
    key: "dispatch",
    value: function dispatch(a0, a1, a2, a3, a4) {
      var node = this._first;

      while (node) {
        node.fn.call(node.ctx, a0, a1, a2, a3, a4);
        node.once && this.unsubscribe(node);
        node = node.next;
      }
    }
  }, {
    key: "subscribe",
    value: function subscribe(fn, ctx, once) {
      var node = new SignalListener(this, fn, ctx, once);

      if (!this._first) {
        this._first = node;
        this._last = node;
      } else {
        this._last.next = node;
        node.prev = this._last;
        this._last = node;
      }

      return node;
    }
  }, {
    key: "subscribeOnce",
    value: function subscribeOnce(fn, ctx) {
      return this.subscribe(fn, ctx, true);
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe(fn, ctx) {
      if (fn instanceof SignalListener) return removeNode(this, fn);
      if (!ctx) ctx = null;
      var node = this._first;

      while (node) {
        if (node.fn === fn && node.ctx === ctx) removeNode(this, node);
        node = node.next;
      }
    }
  }, {
    key: "unsubscribeAll",
    value: function unsubscribeAll() {
      var node = this._first;
      this._first = this._last = null;

      while (node) {
        removeNode(this, node);
        node = node.next;
      }
    }
  }]);

  return Signal;
}();


function signal() {
  return new Signal();
}

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Writable; });
/* harmony export (immutable) */ __webpack_exports__["b"] = writable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__readable__ = __webpack_require__(13);







var Writable =
/*#__PURE__*/
function (_Readable) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Writable, _Readable);

  function Writable() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Writable);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Writable).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Writable, [{
    key: "set",
    value: function set(value, force) {
      if (!force && this.current === value) return;
      var previous = this.current;
      this.current = value;
      var node = this._first;

      while (node) {
        node.fn.call(node.ctx, this.current, previous);
        node.once && this.unsubscribe(node);
        node = node.next;
      }
    }
  }, {
    key: "update",
    value: function update(cb, force) {
      var value = cb(this.current);
      this.set(value !== undefined ? value : this.current, force);
    }
  }]);

  return Writable;
}(__WEBPACK_IMPORTED_MODULE_5__readable__["a" /* Readable */]);


function writable(v) {
  return new Writable(v);
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(40);

var iterableToArray = __webpack_require__(41);

var nonIterableSpread = __webpack_require__(42);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_random__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fast_random___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fast_random__);

var seed = Date.now();
var randomizer = __WEBPACK_IMPORTED_MODULE_0_fast_random___default()(seed);
/* harmony default export */ __webpack_exports__["a"] = ({
  set seed(newSeed) {
    // Seed must be an integer
    seed = newSeed;
    randomizer = __WEBPACK_IMPORTED_MODULE_0_fast_random___default()(seed);
  },

  get seed() {
    return seed;
  },

  reset: function reset() {
    randomizer = __WEBPACK_IMPORTED_MODULE_0_fast_random___default()(seed);
  },
  random: function random() {
    return randomizer.nextFloat();
  },
  randomOf: function randomOf(arr) {
    return arr[Math.floor(randomizer.nextFloat() * arr.length)];
  },
  shuffle: function shuffle(arr) {
    var j, x;

    for (var i = arr.length - 1; i > 0; i--) {
      j = Math.floor(randomizer.nextFloat() * (i + 1));
      x = arr[i];
      arr[i] = arr[j];
      arr[j] = x;
    }

    return arr;
  },
  randomFloat: function randomFloat(min, max) {
    return randomizer.nextFloat() * (max - min) + min;
  },
  randomInt: function randomInt(min, max) {
    return Math.floor(randomizer.nextFloat() * (max - min) + min);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(h) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Cell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_jsx__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_prng__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__ = __webpack_require__(10);











var Cell =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(Cell, _Component);

  function Cell() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Cell);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(Cell).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Cell, [{
    key: "beforeRender",
    value: function beforeRender(props) {
      this.handleClick = this.handleClick.bind(this);
      this.state = {
        id: "".concat(props.x, "_").concat(props.y),
        position: [props.x * __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].cell.size.get(), props.y * __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].cell.size.get()],
        width: props.width * __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].cell.size.get(),
        height: props.height * __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].cell.size.get(),
        symbolID: __WEBPACK_IMPORTED_MODULE_8_utils_prng__["a" /* default */].randomOf(__WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["b" /* default */]).filename
      };
    }
  }, {
    key: "template",
    value: function template(props) {
      var _this$state = this.state,
          id = _this$state.id,
          position = _this$state.position,
          width = _this$state.width,
          height = _this$state.height;
      var ratio = width / height;
      return h("g", {
        class: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('cell', props.class),
        transform: "translate(".concat(position, ")"),
        "event-click": this.handleClick
      }, h("clipPath", {
        id: id,
        ref: this.ref('clipPath')
      }, h("rect", {
        width: ratio >= 1 ? __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */] : __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */] * ratio,
        height: ratio >= 1 ? __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */] / ratio : __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */]
      })), h("rect", {
        width: width,
        height: height,
        fill: props.color
      }), h("use", {
        href: '#' + this.state.symbolID,
        "clip-path": "url(#".concat(id, ")"),
        ref: this.ref('use'),
        x: 0,
        y: 0,
        width: __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */],
        height: __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */],
        transform: "scale(".concat(Math.max(width, height) / __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */], ")")
      }));
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.refs.use.remove();
      this.state.symbolID = __WEBPACK_IMPORTED_MODULE_8_utils_prng__["a" /* default */].randomOf(__WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["b" /* default */]).filename;
      this.render(h("use", {
        href: '#' + this.state.symbolID,
        "clip-path": "url(#".concat(this.state.id, ")"),
        ref: this.ref('use'),
        x: 0,
        y: 0,
        width: __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */],
        height: __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */],
        transform: "scale(".concat(Math.max(this.state.width, this.state.height) / __WEBPACK_IMPORTED_MODULE_9_controllers_symbols__["a" /* BASE_UNIT */], ")")
      }), this.base);
      console.log(this);
    }
  }]);

  return Cell;
}(__WEBPACK_IMPORTED_MODULE_7_utils_jsx__["Component"]);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)["h"]))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(20);
module.exports = __webpack_require__(97);


/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(h) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_utils_jsx__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hotkeys_js__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_App__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_controllers_save__ = __webpack_require__(94);







var _render$components = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(Object(__WEBPACK_IMPORTED_MODULE_2_utils_jsx__["render"])(h(__WEBPACK_IMPORTED_MODULE_4_components_App__["a" /* default */], null), document.body).components, 1),
    app = _render$components[0];

Object(__WEBPACK_IMPORTED_MODULE_3_hotkeys_js__["a" /* default */])('w', function () {
  return __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].debug.set(!__WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].debug.current);
});
Object(__WEBPACK_IMPORTED_MODULE_3_hotkeys_js__["a" /* default */])('space', function () {
  return __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].seed.set(Date.now());
});
Object(__WEBPACK_IMPORTED_MODULE_3_hotkeys_js__["a" /* default */])('cmd + s, s', function (e) {
  e.preventDefault();
  Object(__WEBPACK_IMPORTED_MODULE_5_controllers_save__["a" /* default */])(app.refs.wall, __WEBPACK_IMPORTED_MODULE_1_store__["a" /* default */].seed.get());
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)["h"]))

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addRef;
function addRef(obj, key) {
  return function (ref) {
    obj[key] = ref;
  };
}

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__h__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_extend__ = __webpack_require__(7);


function cloneElement(vnode, props) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__h__["a" /* default */])(vnode.nodeName, Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__utils_extend__["a" /* default */])({}, vnode.props), props), arguments.length > 2 ? [].slice.call(arguments, 2) : vnode.children);
}

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Component; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logger__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__render__ = __webpack_require__(12);





var Component =
/*#__PURE__*/
function () {
  function Component() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Component);

    this._parent = null;
    this._collector = {
      refs: [],
      components: [],
      domEvents: [],
      storeEvents: []
    };
    this._storeListeners = [];
    this.refs = {};
    this.state = {};
    this.store = {}; // Contains all component properties and children.
    // Do not modify it directly, recreate a new component using `cloneElement`

    this.props = props || {}; // HTMLElement used as "base" for the component instance.
    // Can also be an array of elements if `template` return an array.

    this.base = null; // Set to true when component is mounted

    this.mounted = false; // Set to true when component is destroyed

    this.destroyed = false;
    this.log = Object(__WEBPACK_IMPORTED_MODULE_2__logger__["a" /* default */])(props.name || this.constructor.name || 'Component', '#fff', '#02024d', props.disableLog).log;
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Component, [{
    key: "storeSubscribe",
    value: function storeSubscribe(store, method, context) {
      var init = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      store.subscribe(method, context);

      this._storeListeners.push([store, method, context]);

      if (init) method.call(context, store.current);
    } // `component.template` will be called during the component
    // initial rendering to create the `component.base` node
    // You can return real dom or jsx

  }, {
    key: "template",
    value: function template() {} // `component.beforeRender` will be called by `render`
    // just before the component template rendering

  }, {
    key: "beforeRender",
    value: function beforeRender() {} // `component.afterRender` will be called by `render`
    // when all the rendered dom tree is rendered

  }, {
    key: "afterRender",
    value: function afterRender() {} // `component.afterMount` will be called by `render`
    // when all the rendered dom tree is mounted

  }, {
    key: "afterMount",
    value: function afterMount() {} // `component.beforeDestroy` will be called
    // when the component or one of its ancestors is destroyed

  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {} // Quickly add ref to component

  }, {
    key: "ref",
    value: function ref(k) {
      var self = this;
      return function updateRef(el) {
        self.refs[k] = el;
      };
    } // Quickly add ref to an array of component refs

  }, {
    key: "refArray",
    value: function refArray(k) {
      var poolable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var arr = this.refs[k] || (this.refs[k] = []);
      var index = arr.length;
      var pools, pool;

      if (poolable) {
        pools = this.refs.__pools || (this.refs.__pools = {});
        pool = pools[k] || (pools[k] = []);
        if (pool.length) index = pool.pop();
      }

      arr[index] = null;
      return function updateRefArray(el) {
        arr[index] = el;
        if (poolable) pool.push(index);
      };
    } // Quickly add ref to a hashmap of component refs

  }, {
    key: "refMap",
    value: function refMap(k) {
      var id = {}; // SYMBOL FALLBACK

      var map = this.refs[k] || (this.refs[k] = new Map());
      return function updateRefHashmap(el) {
        if (el) map.set(id, el);else map.delete(id);
      };
    } // Render a vnode or array of vnodes
    // and register the rendered content as "child" of this component.
    // Use this method when you want to add content to the component
    // after the initial rendering. This ensures new items will be
    // correctly unmount when the component is destroyed.

  }, {
    key: "render",
    value: function render(vdom, parent) {
      return Object(__WEBPACK_IMPORTED_MODULE_3__render__["a" /* default */])(vdom, parent, this);
    } // Destroy the component and its children components.
    // - This also removes component props and de-reference it from its parent.
    // - Callback refs inside the component tree will be re-called with `null`
    // - Set component.mounted to false

  }, {
    key: "destroy",
    value: function destroy() {
      var i = 0;
      this.beforeDestroy(this.props); // Unlisten to dom events

      for (i = this._collector.domEvents.length - 1; i >= 0; i--) {
        var event = this._collector.domEvents[i];
        event.el.removeEventListener(event.evt, event.fn);
      } // Unlisten to store events


      for (i = this._collector.storeEvents.length - 1; i >= 0; i--) {
        var _event = this._collector.storeEvents[i];

        _event.store.unsubscribe(_event.fn);
      } // Unlisten to store events 2


      for (i = this._storeListeners.length - 1; i >= 0; i--) {
        var _event2 = this._storeListeners[i];

        _event2[0].unsubscribe(_event2[1], _event2[2]);
      } // destroy subcomponents


      for (i = this._collector.components.length - 1; i >= 0; i--) {
        this._collector.components[i].destroy();
      }

      this.mounted = false;
      this.destroyed = true; // unregister component from parent and dispose _parent

      if (this._parent) {
        var index = this._parent._collector.components.indexOf(this);

        if (~index) this._parent._collector.components.splice(index, 1);
        this._parent = null;
      } // callback all ref with null and destroy them from the collector


      for (i = this._collector.refs.length - 1; i >= 0; i--) {
        this._collector.refs[i].fn(null);

        this._collector.refs.splice(i, 1);
      } // Unmount from dom


      var base = Array.isArray(this.base) ? this.base : [this.base];

      for (i = 0; i < base.length; i++) {
        if (base[i] && base[i].parentNode) base[i].parentNode.removeChild(base[i]);
      } // Remove base


      this.base = base = null; // Remove props / state / store / refs to avoid memory leaks

      this.props = null;
      this.state = null;
      this.store = null;
      this.refs = null;
      this._storeListeners = null;
    }
  }]);

  return Component;
}();



/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// All-purpose logger
function noop() {}

var noopObj = {
  log: noop,
  warn: noop,
  error: noop
};

var logger = function logger() {
  return noopObj;
}; /// #if DEVELOPMENT


logger = function logger(prefix, color, background, mute) {
  var _console$log, _console$warn, _console$error;

  if (mute) return noopObj;
  var pre = [];
  prefix = prefix.toUpperCase();
  pre.push("%c ".concat(prefix, " "));
  var style = 'font-weight:bold;';
  if (color) style += "color:".concat(color, ";");
  if (background) style += "background-color:".concat(background);
  pre.push(style);
  return {
    log: (_console$log = console.log).bind.apply(_console$log, [console].concat(pre)),
    warn: (_console$warn = console.warn).bind.apply(_console$warn, [console].concat(pre)),
    error: (_console$error = console.error).bind.apply(_console$error, [console].concat(pre))
  };
}; /// #endif


/* harmony default export */ __webpack_exports__["a"] = (logger);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Collector__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setDomAttrib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extend__ = __webpack_require__(7);





function arr(e) {
  return Array.isArray(e) ? e : [e];
} // ---- RAW RENDERER ----


function rawRender(vdom, isSvg) {
  if (Array.isArray(vdom)) return renderArray(vdom, isSvg);
  if (vdom instanceof window.Element) return renderDirectDom(vdom, isSvg);
  if (vdom === null || __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(vdom) !== 'object' || !vdom.vnode) return renderPrimitive(vdom, isSvg); // one-level deep flatten children array

  var props = Object(__WEBPACK_IMPORTED_MODULE_3__extend__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__extend__["a" /* default */])({}, vdom.props), {
    children: [].concat.apply([], vdom.children || [])
  });
  if (vdom.isDom) return renderDom(vdom, props, isSvg);
  if (vdom.isInstance) return renderClass(vdom, props, isSvg, true);
  if (vdom.isStateless) return renderStateless(vdom, props, isSvg);
  if (vdom.isComponent) return renderClass(vdom, props, isSvg);
} // ---- ARRAY ----


function renderArray(vdoms, isSvg) {
  vdoms = arr(vdoms);
  var collector = new __WEBPACK_IMPORTED_MODULE_1__Collector__["a" /* default */]();

  for (var i = 0; i < vdoms.length; i++) {
    collector.append(rawRender(vdoms[i], isSvg));
  }

  return collector.get();
} // ---- PRIMITIVE ----


function renderPrimitive(vdom) {
  var collector = new __WEBPACK_IMPORTED_MODULE_1__Collector__["a" /* default */]();
  if (vdom === null || vdom === undefined || vdom === false) return collector.get();
  collector.append({
    nodes: document.createTextNode(vdom + '')
  });
  return collector.get();
} // ---- DOM ----


function renderDom(vdom, props, isSvg) {
  // Render and collect vdom's children
  var collector = new __WEBPACK_IMPORTED_MODULE_1__Collector__["a" /* default */]();
  var domChildren = [];
  if (vdom.type === 'svg') isSvg = true;

  for (var i = 0; i < props.children.length; i++) {
    var result = rawRender(props.children[i], isSvg);

    if (result.nodes) {
      domChildren = domChildren.concat(result.nodes);
      collector.append({
        components: result.components,
        refs: result.refs,
        domEvents: result.domEvents,
        storeEvents: result.storeEvents
      });
    }
  } // Create dom element


  var el = isSvg ? document.createElementNS('http://www.w3.org/2000/svg', vdom.type) : document.createElement(vdom.type);

  for (var k in vdom.props) {
    Object(__WEBPACK_IMPORTED_MODULE_2__setDomAttrib__["a" /* default */])(el, k, vdom.props[k], collector, isSvg);
  }

  for (var _i = 0; _i < domChildren.length; _i++) {
    el.appendChild(domChildren[_i]);
  }

  if (props.ref) collector.append({
    refs: {
      ref: el,
      fn: props.ref
    }
  });
  collector.append({
    nodes: el
  });
  return collector.get();
} // ---- DIRECT DOM ----


function renderDirectDom(vdom) {
  var collector = new __WEBPACK_IMPORTED_MODULE_1__Collector__["a" /* default */]();
  collector.append({
    nodes: vdom
  });
  return collector.get();
} // ---- STATELESS ----


function renderStateless(_vdom, props, isSvg) {
  var collector = new __WEBPACK_IMPORTED_MODULE_1__Collector__["a" /* default */]();

  var vdom = _vdom.type(props);

  collector.append(rawRender(vdom, isSvg));
  return collector.get();
} // ---- CLASS ----


function renderClass(_vdom, props, isSvg) {
  var isInstance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var collector = new __WEBPACK_IMPORTED_MODULE_1__Collector__["a" /* default */](); // instanciate it and call beforeRender

  var instance = isInstance ? _vdom.type : new _vdom.type(props); // eslint-disable-line

  if (isInstance) props = instance.props;
  instance.beforeRender(props);
  var vdom = instance.template(props); // append its own ref ? not sur if I need to do this here or in the collector reset

  if (props.ref) collector.append({
    refs: {
      ref: instance,
      fn: props.ref
    }
  });
  collector.append(rawRender(vdom, isSvg)); // create a useful "base" property

  var nodes = collector.data.nodes;
  instance.base = nodes.length > 1 ? nodes : nodes[0]; // collect all sub refs / components and add them to the instance's own collector
  // instance._collector = {}

  for (var k in collector.data) {
    if (k === 'nodes') continue;
    if (!instance._collector[k]) instance._collector[k] = [];
    instance._collector[k] = instance._collector[k].concat(collector.data[k]);
  } // reset the collector (collector.components only contains the current instance)
  // used for possible parents and for correct didmount / refs dispatching


  collector.set({
    components: [instance],
    refs: [],
    domEvents: [],
    storeEvents: []
  }); // add a parent "private" property to each sub-components

  for (var i = 0; i < instance._collector.components.length; i++) {
    instance._collector.components[i]._parent = instance;
  }

  return collector.get();
}

/* harmony default export */ __webpack_exports__["a"] = (rawRender);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Collector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);


var TYPES = ['nodes', 'components', 'refs', 'domEvents', 'storeEvents'];

var Collector =
/*#__PURE__*/
function () {
  function Collector() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, Collector);

    this.data = {};

    for (var i = 0; i < TYPES.length; i++) {
      this.data[TYPES[i]] = [];
    }
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(Collector, [{
    key: "append",
    value: function append(obj) {
      for (var k in obj) {
        this.data[k] = this.data[k].concat(obj[k]);
      }
    }
  }, {
    key: "set",
    value: function set(obj) {
      for (var k in obj) {
        this.data[k] = obj[k];
      }
    }
  }, {
    key: "get",
    value: function get() {
      return this.data;
    }
  }]);

  return Collector;
}();



/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__extend__ = __webpack_require__(7);

// Some portions of code are taken from preact
// https://github.com/developit/preact/blob/master/src/dom/index.js

var namespaces = ['xlink', 'xmlns', 'xml']; // Some attribute doesn't work well when used online as node.attr = value
// We double it with node.setAttribute

var doubleAttr = new Set(['placeholder', 'autoplay', 'muted', 'for', 'webkit-playsinline', 'playsinline', 'selected']);
var val;

var startsWith = function startsWith(str, w) {
  return str.substr(0, w.length) === w;
};

var updateClass = function updateClass(n) {
  return function (v, el) {
    return el.classList.toggle(n, v || false);
  };
};

var updateAttrib = function updateAttrib() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'textContent';
  var isSvg = arguments.length > 1 ? arguments[1] : undefined;
  return function (v, el) {
    var ns = isSvg && name !== (name = name.replace(/^xlink:?/, ''));
    if (ns) el.setAttributeNS('http://www.w3.org/1999/xlink', name.toLowerCase(), v);else {
      val = v == null ? '' : v;
      if (!isSvg) el[name] = val;

      if (isSvg || doubleAttr.has(name) || startsWith(name, 'data-')) {
        el.setAttribute(name, val);
      }
    }
  };
};

function setDomAttrib(el, name, value, collector, isSvg) {
  // Don't treat undefined value
  if (value === undefined) return; // Ignore JSX sourcemap props

  if (name === '__self' || name === '__source') return; // Normalize class attribute

  if (name === 'className') name = 'class'; // Correct attribute like xlmns:xlink

  for (var i = 0; i < namespaces.length; i++) {
    if (startsWith(name, namespaces[i])) {
      var len = namespaces[i].length;

      if (name[len] && name[len] !== ':') {
        name = namespaces[i] + ':' + name[len].toLowerCase() + name.substr(len + 1, name.length);
      }

      break;
    }
  } // Ignored props


  if (name === 'ref') {//
  } else if (startsWith(name, 'event-')) {
    // Synthetic DOM Events
    var eventName = name.toLowerCase().substring(6);
    collector.append({
      domEvents: [{
        el: el,
        evt: eventName,
        fn: value
      }]
    });
  } else if (name === 'store') {
    var evts = Array.isArray(value) ? value : [value];
    var events = [];

    for (var _i = 0, l = evts.length; _i < l; _i++) {
      var evt = Array.isArray(evts[_i]) ? evts[_i] : [evts[_i]];
      var store = evt[0];
      var fn = evt[1];
      var init = evt[2] !== undefined ? evt[2] : true;
      if (!store) continue;
      events.push({
        store: store,
        fn: fn,
        init: init,
        el: el
      });
    }

    collector.append({
      storeEvents: events
    });
  } else if (startsWith(name, 'store-class-')) {
    var className = name.substring(12);

    var _fn = updateClass(className);

    collector.append({
      storeEvents: [{
        store: value,
        init: true,
        fn: _fn,
        el: el
      }]
    });
  } else if (startsWith(name, 'store-')) {
    var attrib = name.substring(6);
    if (attrib === 'text') attrib = 'textContent';

    var _fn2 = updateAttrib(attrib, isSvg);

    collector.append({
      storeEvents: [{
        store: value,
        init: true,
        fn: _fn2,
        el: el
      }]
    });
  } else if (typeof value === 'function' && startsWith(name, 'on')) {// Event attribute (usually do not use this, prefer the synthetic ones)
    // const eventType = name.toLowerCase();
    // el[ eventType ] = value;
  } else if (name === 'class' && !isSvg) {
    // Class - only for non-svg node
    el.className = value || '';
  } else if (name === 'style') {
    // Style attribute
    if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(value) === 'object') Object(__WEBPACK_IMPORTED_MODULE_1__extend__["a" /* default */])(el.style, value);else if (typeof value === 'string') el.style.cssText = value;
  } else if (name !== 'list' && name !== 'type' && !isSvg && name in el) {
    // Attrib
    // Attempt to set an attribute to the given value.
    // IE & FF throw for certain property-value combinations.
    try {
      updateAttrib(name, isSvg)(value, el);
    } catch (e) {
      /* */
    }
  } else if (__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_typeof___default()(value) !== 'object' && typeof value !== 'function') {
    updateAttrib(name, isSvg)(value, el);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (setDomAttrib);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dispatch;
/* harmony export (immutable) */ __webpack_exports__["c"] = dispatchRefs;
/* harmony export (immutable) */ __webpack_exports__["b"] = dispatchListeners;
function dispatch(component, cb, topDown) {
  var subs = component._collector && component._collector.components;
  if (topDown) cb(component);

  if (subs) {
    for (var i = 0; i < subs.length; i++) {
      dispatch(subs[i], cb);
    }
  }

  if (!topDown) cb(component);
}

function callRefs(component) {
  for (var i = 0; i < component._collector.refs.length; i++) {
    component._collector.refs[i].fn(component._collector.refs[i].ref); // Is this really needed or a good thing ?


    component._collector.refs[i].ref = null;
  }
}

function callStoreListeners(component) {
  var _loop = function _loop(i) {
    var event = component._collector.storeEvents[i];
    var oldfn = event.fn;

    event.fn = function (v) {
      oldfn(v, event.el);
    }; // eslint-disable-line


    event.store.subscribe(event.fn);
    if (event.init) event.fn(event.store.current);
  };

  for (var i = 0; i < component._collector.storeEvents.length; i++) {
    _loop(i);
  }
}

function callDomListeners(component) {
  if (component.test) console.log('call dom listeners', component._collector.domEvents);

  for (var i = 0; i < component._collector.domEvents.length; i++) {
    var event = component._collector.domEvents[i];
    event.el.addEventListener(event.evt, event.fn);
  }
}

function dispatchRefs(component) {
  dispatch(component, callRefs);
}
function dispatchListeners(component) {
  dispatch(component, callDomListeners);
  dispatch(component, callStoreListeners);
}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;

/***/ }),
/* 30 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;

/***/ }),
/* 31 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

module.exports = _nonIterableRest;

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__readable__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__writable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__derived__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__signal__ = __webpack_require__(14);
/* unused harmony reexport r */
/* unused harmony reexport w */
/* unused harmony reexport d */
/* unused harmony reexport s */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__readable__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__writable__["b"]; });
/* unused harmony reexport derived */
/* unused harmony reexport signal */






/***/ }),
/* 33 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 34 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__writable__ = __webpack_require__(15);


function derived(observables, cb) {
  var value = new __WEBPACK_IMPORTED_MODULE_0__writable__["a" /* Writable */]();
  var setValue = value.set.bind(value);
  delete value.set;
  var isArray = Array.isArray(observables);
  var values = isArray ? new Array(observables.length) : null;

  if (isArray) {
    var _loop = function _loop(i, l) {
      values[i] = observables[i].current;
      observables[i].subscribe(function (v) {
        values[i] = v;
        derive();
      });
    };

    for (var i = 0, l = observables.length; i < l; i++) {
      _loop(i, l);
    }
  } else {
    values = observables.current;
    observables.subscribe(function (v) {
      values = v;
      derive();
    });
  }

  derive();

  function derive() {
    var result = cb(values);
    if (result && result.then) result.then(setValue);else setValue(result);
  }

  return value;
}

/* unused harmony default export */ var _unused_webpack_default_export = (derived);

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * hotkeys-js v3.8.1
 * A simple micro-library for defining and dispatching keyboard shortcuts. It has no dependencies.
 * 
 * Copyright (c) 2020 kenny wong <wowohoo@qq.com>
 * http://jaywcjlove.github.io/hotkeys
 * 
 * Licensed under the MIT license.
 */

var isff = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase().indexOf('firefox') > 0 : false; // 绑定事件

function addEvent(object, event, method) {
  if (object.addEventListener) {
    object.addEventListener(event, method, false);
  } else if (object.attachEvent) {
    object.attachEvent("on".concat(event), function () {
      method(window.event);
    });
  }
} // 修饰键转换成对应的键码


function getMods(modifier, key) {
  var mods = key.slice(0, key.length - 1);

  for (var i = 0; i < mods.length; i++) {
    mods[i] = modifier[mods[i].toLowerCase()];
  }

  return mods;
} // 处理传的key字符串转换成数组


function getKeys(key) {
  if (typeof key !== 'string') key = '';
  key = key.replace(/\s/g, ''); // 匹配任何空白字符,包括空格、制表符、换页符等等

  var keys = key.split(','); // 同时设置多个快捷键，以','分割

  var index = keys.lastIndexOf(''); // 快捷键可能包含','，需特殊处理

  for (; index >= 0;) {
    keys[index - 1] += ',';
    keys.splice(index, 1);
    index = keys.lastIndexOf('');
  }

  return keys;
} // 比较修饰键的数组


function compareArray(a1, a2) {
  var arr1 = a1.length >= a2.length ? a1 : a2;
  var arr2 = a1.length >= a2.length ? a2 : a1;
  var isIndex = true;

  for (var i = 0; i < arr1.length; i++) {
    if (arr2.indexOf(arr1[i]) === -1) isIndex = false;
  }

  return isIndex;
}

var _keyMap = {
  backspace: 8,
  tab: 9,
  clear: 12,
  enter: 13,
  return: 13,
  esc: 27,
  escape: 27,
  space: 32,
  left: 37,
  up: 38,
  right: 39,
  down: 40,
  del: 46,
  delete: 46,
  ins: 45,
  insert: 45,
  home: 36,
  end: 35,
  pageup: 33,
  pagedown: 34,
  capslock: 20,
  '⇪': 20,
  ',': 188,
  '.': 190,
  '/': 191,
  '`': 192,
  '-': isff ? 173 : 189,
  '=': isff ? 61 : 187,
  ';': isff ? 59 : 186,
  '\'': 222,
  '[': 219,
  ']': 221,
  '\\': 220
}; // Modifier Keys

var _modifier = {
  // shiftKey
  '⇧': 16,
  shift: 16,
  // altKey
  '⌥': 18,
  alt: 18,
  option: 18,
  // ctrlKey
  '⌃': 17,
  ctrl: 17,
  control: 17,
  // metaKey
  '⌘': 91,
  cmd: 91,
  command: 91
};
var modifierMap = {
  16: 'shiftKey',
  18: 'altKey',
  17: 'ctrlKey',
  91: 'metaKey',
  shiftKey: 16,
  ctrlKey: 17,
  altKey: 18,
  metaKey: 91
};
var _mods = {
  16: false,
  18: false,
  17: false,
  91: false
};
var _handlers = {}; // F1~F12 special key

for (var k = 1; k < 20; k++) {
  _keyMap["f".concat(k)] = 111 + k;
}

var _downKeys = []; // 记录摁下的绑定键

var _scope = 'all'; // 默认热键范围

var elementHasBindEvent = []; // 已绑定事件的节点记录
// 返回键码

var code = function code(x) {
  return _keyMap[x.toLowerCase()] || _modifier[x.toLowerCase()] || x.toUpperCase().charCodeAt(0);
}; // 设置获取当前范围（默认为'所有'）


function setScope(scope) {
  _scope = scope || 'all';
} // 获取当前范围


function getScope() {
  return _scope || 'all';
} // 获取摁下绑定键的键值


function getPressedKeyCodes() {
  return _downKeys.slice(0);
} // 表单控件控件判断 返回 Boolean
// hotkey is effective only when filter return true


function filter(event) {
  var target = event.target || event.srcElement;
  var tagName = target.tagName;
  var flag = true; // ignore: isContentEditable === 'true', <input> and <textarea> when readOnly state is false, <select>

  if (target.isContentEditable || (tagName === 'INPUT' || tagName === 'TEXTAREA' || tagName === 'SELECT') && !target.readOnly) {
    flag = false;
  }

  return flag;
} // 判断摁下的键是否为某个键，返回true或者false


function isPressed(keyCode) {
  if (typeof keyCode === 'string') {
    keyCode = code(keyCode); // 转换成键码
  }

  return _downKeys.indexOf(keyCode) !== -1;
} // 循环删除handlers中的所有 scope(范围)


function deleteScope(scope, newScope) {
  var handlers;
  var i; // 没有指定scope，获取scope

  if (!scope) scope = getScope();

  for (var key in _handlers) {
    if (Object.prototype.hasOwnProperty.call(_handlers, key)) {
      handlers = _handlers[key];

      for (i = 0; i < handlers.length;) {
        if (handlers[i].scope === scope) handlers.splice(i, 1);else i++;
      }
    }
  } // 如果scope被删除，将scope重置为all


  if (getScope() === scope) setScope(newScope || 'all');
} // 清除修饰键


function clearModifier(event) {
  var key = event.keyCode || event.which || event.charCode;

  var i = _downKeys.indexOf(key); // 从列表中清除按压过的键


  if (i >= 0) {
    _downKeys.splice(i, 1);
  } // 特殊处理 cmmand 键，在 cmmand 组合快捷键 keyup 只执行一次的问题


  if (event.key && event.key.toLowerCase() === 'meta') {
    _downKeys.splice(0, _downKeys.length);
  } // 修饰键 shiftKey altKey ctrlKey (command||metaKey) 清除


  if (key === 93 || key === 224) key = 91;

  if (key in _mods) {
    _mods[key] = false; // 将修饰键重置为false

    for (var k in _modifier) {
      if (_modifier[k] === key) hotkeys[k] = false;
    }
  }
}

function unbind(keysInfo) {
  // unbind(), unbind all keys
  if (!keysInfo) {
    Object.keys(_handlers).forEach(function (key) {
      return delete _handlers[key];
    });
  } else if (Array.isArray(keysInfo)) {
    // support like : unbind([{key: 'ctrl+a', scope: 's1'}, {key: 'ctrl-a', scope: 's2', splitKey: '-'}])
    keysInfo.forEach(function (info) {
      if (info.key) eachUnbind(info);
    });
  } else if (typeof keysInfo === 'object') {
    // support like unbind({key: 'ctrl+a, ctrl+b', scope:'abc'})
    if (keysInfo.key) eachUnbind(keysInfo);
  } else if (typeof keysInfo === 'string') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    // support old method
    // eslint-disable-line
    var scope = args[0],
        method = args[1];

    if (typeof scope === 'function') {
      method = scope;
      scope = '';
    }

    eachUnbind({
      key: keysInfo,
      scope: scope,
      method: method,
      splitKey: '+'
    });
  }
} // 解除绑定某个范围的快捷键


var eachUnbind = function eachUnbind(_ref) {
  var key = _ref.key,
      scope = _ref.scope,
      method = _ref.method,
      _ref$splitKey = _ref.splitKey,
      splitKey = _ref$splitKey === void 0 ? '+' : _ref$splitKey;
  var multipleKeys = getKeys(key);
  multipleKeys.forEach(function (originKey) {
    var unbindKeys = originKey.split(splitKey);
    var len = unbindKeys.length;
    var lastKey = unbindKeys[len - 1];
    var keyCode = lastKey === '*' ? '*' : code(lastKey);
    if (!_handlers[keyCode]) return; // 判断是否传入范围，没有就获取范围

    if (!scope) scope = getScope();
    var mods = len > 1 ? getMods(_modifier, unbindKeys) : [];
    _handlers[keyCode] = _handlers[keyCode].map(function (record) {
      // 通过函数判断，是否解除绑定，函数相等直接返回
      var isMatchingMethod = method ? record.method === method : true;

      if (isMatchingMethod && record.scope === scope && compareArray(record.mods, mods)) {
        return {};
      }

      return record;
    });
  });
}; // 对监听对应快捷键的回调函数进行处理


function eventHandler(event, handler, scope) {
  var modifiersMatch; // 看它是否在当前范围

  if (handler.scope === scope || handler.scope === 'all') {
    // 检查是否匹配修饰符（如果有返回true）
    modifiersMatch = handler.mods.length > 0;

    for (var y in _mods) {
      if (Object.prototype.hasOwnProperty.call(_mods, y)) {
        if (!_mods[y] && handler.mods.indexOf(+y) > -1 || _mods[y] && handler.mods.indexOf(+y) === -1) {
          modifiersMatch = false;
        }
      }
    } // 调用处理程序，如果是修饰键不做处理


    if (handler.mods.length === 0 && !_mods[16] && !_mods[18] && !_mods[17] && !_mods[91] || modifiersMatch || handler.shortcut === '*') {
      if (handler.method(event, handler) === false) {
        if (event.preventDefault) event.preventDefault();else event.returnValue = false;
        if (event.stopPropagation) event.stopPropagation();
        if (event.cancelBubble) event.cancelBubble = true;
      }
    }
  }
} // 处理keydown事件


function dispatch(event) {
  var asterisk = _handlers['*'];
  var key = event.keyCode || event.which || event.charCode; // 表单控件过滤 默认表单控件不触发快捷键

  if (!hotkeys.filter.call(this, event)) return; // Gecko(Firefox)的command键值224，在Webkit(Chrome)中保持一致
  // Webkit左右 command 键值不一样

  if (key === 93 || key === 224) key = 91;
  /**
   * Collect bound keys
   * If an Input Method Editor is processing key input and the event is keydown, return 229.
   * https://stackoverflow.com/questions/25043934/is-it-ok-to-ignore-keydown-events-with-keycode-229
   * http://lists.w3.org/Archives/Public/www-dom/2010JulSep/att-0182/keyCode-spec.html
   */

  if (_downKeys.indexOf(key) === -1 && key !== 229) _downKeys.push(key);
  /**
   * Jest test cases are required.
   * ===============================
   */

  ['ctrlKey', 'altKey', 'shiftKey', 'metaKey'].forEach(function (keyName) {
    var keyNum = modifierMap[keyName];

    if (event[keyName] && _downKeys.indexOf(keyNum) === -1) {
      _downKeys.push(keyNum);
    } else if (!event[keyName] && _downKeys.indexOf(keyNum) > -1) {
      _downKeys.splice(_downKeys.indexOf(keyNum), 1);
    } else if (keyName === 'metaKey' && event[keyName] && _downKeys.length === 3) {
      /**
       * Fix if Command is pressed:
       * ===============================
       */
      if (!(event.ctrlKey || event.shiftKey || event.altKey)) {
        _downKeys = _downKeys.slice(_downKeys.indexOf(keyNum));
      }
    }
  });
  /**
   * -------------------------------
   */

  if (key in _mods) {
    _mods[key] = true; // 将特殊字符的key注册到 hotkeys 上

    for (var k in _modifier) {
      if (_modifier[k] === key) hotkeys[k] = true;
    }

    if (!asterisk) return;
  } // 将 modifierMap 里面的修饰键绑定到 event 中


  for (var e in _mods) {
    if (Object.prototype.hasOwnProperty.call(_mods, e)) {
      _mods[e] = event[modifierMap[e]];
    }
  }
  /**
   * https://github.com/jaywcjlove/hotkeys/pull/129
   * This solves the issue in Firefox on Windows where hotkeys corresponding to special characters would not trigger.
   * An example of this is ctrl+alt+m on a Swedish keyboard which is used to type μ.
   * Browser support: https://caniuse.com/#feat=keyboardevent-getmodifierstate
   */


  if (event.getModifierState && !(event.altKey && !event.ctrlKey) && event.getModifierState('AltGraph')) {
    if (_downKeys.indexOf(17) === -1) {
      _downKeys.push(17);
    }

    if (_downKeys.indexOf(18) === -1) {
      _downKeys.push(18);
    }

    _mods[17] = true;
    _mods[18] = true;
  } // 获取范围 默认为 `all`


  var scope = getScope(); // 对任何快捷键都需要做的处理

  if (asterisk) {
    for (var i = 0; i < asterisk.length; i++) {
      if (asterisk[i].scope === scope && (event.type === 'keydown' && asterisk[i].keydown || event.type === 'keyup' && asterisk[i].keyup)) {
        eventHandler(event, asterisk[i], scope);
      }
    }
  } // key 不在 _handlers 中返回


  if (!(key in _handlers)) return;

  for (var _i = 0; _i < _handlers[key].length; _i++) {
    if (event.type === 'keydown' && _handlers[key][_i].keydown || event.type === 'keyup' && _handlers[key][_i].keyup) {
      if (_handlers[key][_i].key) {
        var record = _handlers[key][_i];
        var splitKey = record.splitKey;
        var keyShortcut = record.key.split(splitKey);
        var _downKeysCurrent = []; // 记录当前按键键值

        for (var a = 0; a < keyShortcut.length; a++) {
          _downKeysCurrent.push(code(keyShortcut[a]));
        }

        if (_downKeysCurrent.sort().join('') === _downKeys.sort().join('')) {
          // 找到处理内容
          eventHandler(event, record, scope);
        }
      }
    }
  }
} // 判断 element 是否已经绑定事件


function isElementBind(element) {
  return elementHasBindEvent.indexOf(element) > -1;
}

function hotkeys(key, option, method) {
  _downKeys = [];
  var keys = getKeys(key); // 需要处理的快捷键列表

  var mods = [];
  var scope = 'all'; // scope默认为all，所有范围都有效

  var element = document; // 快捷键事件绑定节点

  var i = 0;
  var keyup = false;
  var keydown = true;
  var splitKey = '+'; // 对为设定范围的判断

  if (method === undefined && typeof option === 'function') {
    method = option;
  }

  if (Object.prototype.toString.call(option) === '[object Object]') {
    if (option.scope) scope = option.scope; // eslint-disable-line

    if (option.element) element = option.element; // eslint-disable-line

    if (option.keyup) keyup = option.keyup; // eslint-disable-line

    if (option.keydown !== undefined) keydown = option.keydown; // eslint-disable-line

    if (typeof option.splitKey === 'string') splitKey = option.splitKey; // eslint-disable-line
  }

  if (typeof option === 'string') scope = option; // 对于每个快捷键进行处理

  for (; i < keys.length; i++) {
    key = keys[i].split(splitKey); // 按键列表

    mods = []; // 如果是组合快捷键取得组合快捷键

    if (key.length > 1) mods = getMods(_modifier, key); // 将非修饰键转化为键码

    key = key[key.length - 1];
    key = key === '*' ? '*' : code(key); // *表示匹配所有快捷键
    // 判断key是否在_handlers中，不在就赋一个空数组

    if (!(key in _handlers)) _handlers[key] = [];

    _handlers[key].push({
      keyup: keyup,
      keydown: keydown,
      scope: scope,
      mods: mods,
      shortcut: keys[i],
      method: method,
      key: keys[i],
      splitKey: splitKey
    });
  } // 在全局document上设置快捷键


  if (typeof element !== 'undefined' && !isElementBind(element) && window) {
    elementHasBindEvent.push(element);
    addEvent(element, 'keydown', function (e) {
      dispatch(e);
    });
    addEvent(window, 'focus', function () {
      _downKeys = [];
    });
    addEvent(element, 'keyup', function (e) {
      dispatch(e);
      clearModifier(e);
    });
  }
}

var _api = {
  setScope: setScope,
  getScope: getScope,
  deleteScope: deleteScope,
  getPressedKeyCodes: getPressedKeyCodes,
  isPressed: isPressed,
  filter: filter,
  unbind: unbind
};

for (var a in _api) {
  if (Object.prototype.hasOwnProperty.call(_api, a)) {
    hotkeys[a] = _api[a];
  }
}

if (typeof window !== 'undefined') {
  var _hotkeys = window.hotkeys;

  hotkeys.noConflict = function (deep) {
    if (deep && window.hotkeys === hotkeys) {
      window.hotkeys = _hotkeys;
    }

    return hotkeys;
  };

  window.hotkeys = hotkeys;
}

/* harmony default export */ __webpack_exports__["a"] = (hotkeys);


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(h) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_Wall__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_utils_jsx__ = __webpack_require__(0);









var App =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_inherits___default()(App, _Component);

  function App() {
    __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_classCallCheck___default()(this, App);

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_getPrototypeOf___default()(App).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_createClass___default()(App, [{
    key: "beforeRender",
    value: function beforeRender() {
      this.update = this.update.bind(this);
    }
  }, {
    key: "template",
    value: function template() {
      return h("main", {
        class: "app",
        id: "App",
        "store-class-debug": __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].debug
      }, h("footer", {
        class: "app__footer"
      }, h("div", {
        class: "app__info"
      }, h("kbd", null, "espace"), " pour g\xE9n\xE9rer un nouveau hall", h("br", null), h("kbd", null, "w"), " pour passer en mode debug", h("br", null), h("kbd", null, "cmd"), "+", h("kbd", null, "s"), " pour enregistrer au format SVG"), h("div", {
        class: "app__seed",
        "store-text": __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].seed
      })));
    }
  }, {
    key: "afterRender",
    value: function afterRender() {
      __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].seed.subscribe(this.update);
      this.update();
    }
  }, {
    key: "update",
    value: function update() {
      if (this.refs.wall) this.refs.wall.destroy();
      this.render(h(__WEBPACK_IMPORTED_MODULE_6_components_Wall__["a" /* default */], {
        ref: this.ref('wall')
      }), this.base);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      __WEBPACK_IMPORTED_MODULE_5_store__["a" /* default */].seed.unsubscribe(this.update);
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_7_utils_jsx__["Component"]);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)["h"]))

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(h) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Wall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_store__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_utils_jsx__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_utils_prng__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_utils_array_uniq__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_abstractions_VirtualCell__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_Cell__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_HallNumber__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_controllers_symbols__ = __webpack_require__(10);
















var Wall =
/*#__PURE__*/
function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(Wall, _Component);

  function Wall() {
    __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_classCallCheck___default()(this, Wall);

    return __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_getPrototypeOf___default()(Wall).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_createClass___default()(Wall, [{
    key: "beforeRender",
    value: function beforeRender(props) {
      __WEBPACK_IMPORTED_MODULE_9_utils_prng__["a" /* default */].seed = __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].seed.get();
      this.state = {
        cols: __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].wall.cols.get(),
        rows: __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].wall.rows.get(),
        width: __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].wall.cols.get() * __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].cell.size.get(),
        height: __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].wall.rows.get() * __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].cell.size.get(),
        colors: {
          primary: __WEBPACK_IMPORTED_MODULE_9_utils_prng__["a" /* default */].randomOf(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].colors.primary.get()),
          secondary: __WEBPACK_IMPORTED_MODULE_9_utils_prng__["a" /* default */].shuffle(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].colors.secondary.get())).splice(0, __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].colors.length.get())
        }
      };
    }
  }, {
    key: "template",
    value: function template(props) {
      var _this$state = this.state,
          width = _this$state.width,
          height = _this$state.height;
      var symbols = __WEBPACK_IMPORTED_MODULE_14_controllers_symbols__["b" /* default */].map(function (symbol) {
        return h("symbol", {
          id: symbol.filename
        }, symbol.toJsx());
      });
      return h("svg", {
        ref: this.ref('svg'),
        class: "wall",
        width: "".concat(width).concat(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].cell.unit.get()),
        height: "".concat(height).concat(__WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].cell.unit.get()),
        viewBox: "0 0 ".concat(width, " ").concat(height)
      }, h("defs", null, symbols), this.renderCells(), this.renderGrid());
    }
  }, {
    key: "renderCells",
    value: function renderCells() {
      var _this = this;

      // Create a special locked cell wich represents existing occupied cells in
      // the real wall
      var hallNumber = new __WEBPACK_IMPORTED_MODULE_11_abstractions_VirtualCell__["a" /* default */](2, 0, 2, 2, true); // 1 -
      // Create an array of unique position and assign a cell on each one,
      // removing possible cell overlapping with the hall number

      var cells = randomlyFill.call(this, __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].wall.cellsLength.get(), {
        indexes: new Array(this.state.cols * this.state.rows).fill(0).map(function (_, i) {
          return i;
        }),
        existingCells: [hallNumber]
      });
      cells.push(hallNumber); // 2 -
      // Grow cells using a relatively rigid growth strategy, trying to keep a
      // relatively square ratio

      grow([[1, 1, 1, 1], [1, 0, 1, 1], [1, 1, 0, 1], [1, 1, 0, 0], [0, 0, 1, 1], [1, 1, 0, 0], [1, 0, 0, 1], [0, 1, 1, 0]]); // 2 bis -
      // Grow cells using a far more fluid strategy to fill empty spaces

      grow([[1, 0, 0, 0], [0, 1, 0, 0], [0, 0, 1, 0], [0, 0, 0, 1]]); // 3 -
      // Fill possible empty cells left after growth by creating new Cells and
      // growing them with a fluid growth strategy

      var emptyCells = [];
      var iter = 0;

      while (!emptyCells.length && ++iter < 10) {
        emptyCells.length = 0;

        var _loop = function _loop(index) {
          var x = index % _this.state.cols;
          var y = (index - x) / _this.state.cols;
          var isEmpty = !cells.find(function (cell) {
            return cell.contains([x, y]);
          });
          if (isEmpty) emptyCells.push(index);
        };

        for (var index = 0; index < this.state.cols * this.state.rows; index++) {
          _loop(index);
        }

        var newCells = randomlyFill.call(this, Math.ceil(emptyCells.length / 3), {
          indexes: emptyCells,
          existingCells: cells
        });
        newCells.forEach(function (cell) {
          return cells.push(cell);
        });
        grow([[1, 0, 0, 0], [0, 1, 0, 0], [0, 0, 1, 0], [0, 0, 0, 1]]);
      }

      __WEBPACK_IMPORTED_MODULE_9_utils_prng__["a" /* default */].reset(); // Transform virtual cells to jsx

      return cells.sort(function (a, b) {
        return a.y - b.y;
      }).sort(function (a, b) {
        return a.x - b.x;
      }).map(function (_ref, index) {
        var x = _ref.x,
            y = _ref.y,
            width = _ref.width,
            height = _ref.height,
            isLocked = _ref.isLocked;
        var colors = [_this.state.colors.primary].concat(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_toConsumableArray___default()(_this.state.colors.secondary));
        var props = {
          x: x,
          y: y,
          width: width,
          height: height,
          color: colors[index % colors.length]
        };
        return isLocked ? h(__WEBPACK_IMPORTED_MODULE_13_components_HallNumber__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, props, {
          number: __WEBPACK_IMPORTED_MODULE_9_utils_prng__["a" /* default */].randomInt(1, 22)
        })) // TODO: number based on primary color
        : h(__WEBPACK_IMPORTED_MODULE_12_components_Cell__["a" /* default */], props);
      }); // Return an array of VirtualCell from an array of 1D indexes representing
      // possible cell positions

      function randomlyFill(length, _ref2) {
        var _this2 = this;

        var _ref2$indexes = _ref2.indexes,
            indexes = _ref2$indexes === void 0 ? [] : _ref2$indexes,
            _ref2$existingCells = _ref2.existingCells,
            existingCells = _ref2$existingCells === void 0 ? [] : _ref2$existingCells;
        return __WEBPACK_IMPORTED_MODULE_9_utils_prng__["a" /* default */].shuffle(Object(__WEBPACK_IMPORTED_MODULE_10_utils_array_uniq__["a" /* default */])(indexes)).splice(0, length).map(function (index) {
          var x = index % _this2.state.cols;
          var y = (index - x) / _this2.state.cols;
          return new __WEBPACK_IMPORTED_MODULE_11_abstractions_VirtualCell__["a" /* default */](x, y);
        }).filter(function (cell) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = existingCells[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var existingCell = _step.value;
              if (cell.intersects(existingCell)) return false;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return true;
        });
      } // Grow all cells sequentially based on a growth strategy, until no cell
      // cannot grow anymore


      function grow(growthStrategy) {
        while (true) {
          var hasGrown = false;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = cells[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var cell = _step2.value;
              hasGrown = cell.grow(cells, growthStrategy);
              if (hasGrown) break;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          if (!hasGrown) break;
        }
      }
    }
  }, {
    key: "renderGrid",
    value: function renderGrid() {
      var marks = [];
      var size = __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].cell.size.get() * 0.5;

      for (var x = 0; x <= this.state.cols; x++) {
        for (var y = 0; y <= this.state.rows; y++) {
          var position = [x * __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].cell.size.get(), y * __WEBPACK_IMPORTED_MODULE_7_store__["a" /* default */].cell.size.get()];
          marks.push(h("g", {
            class: "grid__mark",
            transform: "translate(".concat(position, ")")
          }, h("line", {
            x1: 0,
            y1: -size,
            x2: 0,
            y2: size,
            stroke: "black"
          }), h("line", {
            x1: -size,
            y1: 0,
            x2: size,
            y2: 0,
            stroke: "black"
          })));
        }
      }

      return h("g", {
        class: "grid no-export"
      }, marks);
    }
  }, {
    key: "svgString",
    get: function get() {
      // Working on a cloned node so that we can mutate and remove elements
      var clonedSvg = this.refs.svg.cloneNode(true);
      clonedSvg.querySelectorAll('.no-export').forEach(function (el) {
        return el.remove();
      });
      return clonedSvg.outerHTML.replace('<svg', '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"').replace(/href/g, 'xlink:href');
    }
  }]);

  return Wall;
}(__WEBPACK_IMPORTED_MODULE_8_utils_jsx__["Component"]);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)["h"]))

/***/ }),
/* 39 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 40 */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),
/* 41 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),
/* 42 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),
/* 43 */
/***/ (function(module, exports) {

function random(seed) {
	function _seed(s) {
		if ((seed = (s|0) % 2147483647) <= 0) {
			seed += 2147483646;
		}
	}

	function _nextInt() {
		return seed = seed * 48271 % 2147483647;
	}

	function _nextFloat() {
		return (_nextInt() - 1) / 2147483646;
	}

	_seed(seed);

	return {
		seed: _seed,
		nextInt: _nextInt,
		nextFloat: _nextFloat
	};
}

module.exports = random;


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray__);

/* harmony default export */ __webpack_exports__["a"] = (function (arr) {
  return __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_toConsumableArray___default()(new Set(arr));
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VirtualCell; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_store__ = __webpack_require__(6);




var GROWTH_STRATEGIES = [[1, 1, 1, 1], [1, 0, 1, 1], [1, 1, 0, 1], [1, 1, 0, 0], [0, 0, 1, 1], [1, 1, 0, 0], [1, 0, 0, 1], [0, 1, 1, 0]];

var VirtualCell =
/*#__PURE__*/
function () {
  function VirtualCell(x, y) {
    var width = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var height = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
    var isLocked = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, VirtualCell);

    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.isLocked = isLocked;
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(VirtualCell, [{
    key: "project",
    value: function project() {
      var growth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [0, 0, 0, 0];
      return {
        xmin: this.x - growth[0],
        ymin: this.y - growth[1],
        xmax: this.x + this.width + growth[2],
        ymax: this.y + this.height + growth[3],
        ratio: (this.width + growth[2] - growth[0]) / (this.height + growth[3] - growth[1])
      };
    }
  }, {
    key: "intersects",
    value: function intersects(cell) {
      var growth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [0, 0, 0, 0];

      var _this$project = this.project(growth),
          xmin = _this$project.xmin,
          xmax = _this$project.xmax,
          ymin = _this$project.ymin,
          ymax = _this$project.ymax;

      return this !== cell && xmin < cell.xmax && xmax > cell.x && ymin < cell.ymax && ymax > cell.y;
    }
  }, {
    key: "contains",
    value: function contains(_ref) {
      var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref, 2),
          x = _ref2[0],
          y = _ref2[1];

      return x >= this.x && x < this.xmax && y >= this.y && y < this.ymax;
    }
  }, {
    key: "overflows",
    value: function overflows(growth) {
      var cols = __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].wall.cols.get();
      var rows = __WEBPACK_IMPORTED_MODULE_3_store__["a" /* default */].wall.rows.get();

      var _this$project2 = this.project(growth),
          xmin = _this$project2.xmin,
          xmax = _this$project2.xmax,
          ymin = _this$project2.ymin,
          ymax = _this$project2.ymax;

      return xmin < 0 || ymin < 0 || xmax > cols || ymax > rows;
    }
  }, {
    key: "grow",
    value: function grow(cells) {
      var _this = this;

      var growthStrategy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : GROWTH_STRATEGIES;
      var hasGrown = false;
      if (this.isLocked) return hasGrown;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop2 = function _loop2() {
          var growth = _step.value;
          var hit = cells.find(function (cell) {
            return _this.intersects(cell, growth);
          });
          if (hit || _this.overflows(growth)) return "continue";
          _this.x -= growth[0];
          _this.y -= growth[1];
          _this.width += growth[0] + growth[2];
          _this.height += growth[1] + growth[3];
          hasGrown = true;
          return "break";
        };

        _loop: for (var _iterator = growthStrategy[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ret = _loop2();

          switch (_ret) {
            case "continue":
              continue;

            case "break":
              break _loop;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return hasGrown;
    }
  }, {
    key: "xmax",
    get: function get() {
      return this.x + this.width;
    }
  }, {
    key: "ymax",
    get: function get() {
      return this.y + this.height;
    }
  }]);

  return VirtualCell;
}();



/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parse; });
function getLocator(source, options) {
    if (options === void 0) { options = {}; }
    var offsetLine = options.offsetLine || 0;
    var offsetColumn = options.offsetColumn || 0;
    var originalLines = source.split('\n');
    var start = 0;
    var lineRanges = originalLines.map(function (line, i) {
        var end = start + line.length + 1;
        var range = { start: start, end: end, line: i };
        start = end;
        return range;
    });
    var i = 0;
    function rangeContains(range, index) {
        return range.start <= index && index < range.end;
    }
    function getLocation(range, index) {
        return { line: offsetLine + range.line, column: offsetColumn + index - range.start, character: index };
    }
    function locate(search, startIndex) {
        if (typeof search === 'string') {
            search = source.indexOf(search, startIndex || 0);
        }
        var range = lineRanges[i];
        var d = search >= range.end ? 1 : -1;
        while (range) {
            if (rangeContains(range, search))
                return getLocation(range, search);
            i += d;
            range = lineRanges[i];
        }
    }
    return locate;
}
function locate(source, search, options) {
    if (typeof options === 'number') {
        throw new Error('locate takes a { startIndex, offsetLine, offsetColumn } object as the third argument');
    }
    return getLocator(source, options)(search, options && options.startIndex);
}

var validNameCharacters = /[a-zA-Z0-9:_-]/;
var whitespace = /[\s\t\r\n]/;
var quotemark = /['"]/;

function repeat(str, i) {
	var result = '';
	while (i--) { result += str; }
	return result;
}

function parse(source) {
	var header = '';
	var stack = [];

	var state = metadata;
	var currentElement = null;
	var root = null;

	function error(message) {
		var ref = locate(source, i);
		var line = ref.line;
		var column = ref.column;
		var before = source.slice(0, i);
		var beforeLine = /(^|\n).*$/.exec(before)[0].replace(/\t/g, '  ');
		var after = source.slice(i);
		var afterLine = /.*(\n|$)/.exec(after)[0];

		var snippet = "" + beforeLine + afterLine + "\n" + (repeat(' ', beforeLine.length)) + "^";

		throw new Error(
			(message + " (" + line + ":" + column + "). If this is valid SVG, it's probably a bug in svg-parser. Please raise an issue at https://github.com/Rich-Harris/svg-parser/issues – thanks!\n\n" + snippet)
		);
	}

	function metadata() {
		while ((i < source.length && source[i] !== '<') || !validNameCharacters.test(source[i + 1])) {
			header += source[i++];
		}

		return neutral();
	}

	function neutral() {
		var text = '';
		while (i < source.length && source[i] !== '<') { text += source[i++]; }

		if (/\S/.test(text)) {
			currentElement.children.push({ type: 'text', value: text });
		}

		if (source[i] === '<') {
			return tag;
		}

		return neutral;
	}

	function tag() {
		var char = source[i];

		if (char === '?') { return neutral; } // <?xml...

		if (char === '!') {
			if (source.slice(i + 1, i + 3) === '--') { return comment; }
			if (source.slice(i + 1, i + 8) === '[CDATA[') { return cdata; }
			if (/doctype/i.test(source.slice(i + 1, i + 8))) { return neutral; }
		}

		if (char === '/') { return closingTag; }

		var tagName = getName();

		var element = {
			type: 'element',
			tagName: tagName,
			properties: {},
			children: []
		};

		if (currentElement) {
			currentElement.children.push(element);
		} else {
			root = element;
		}

		var attribute;
		while (i < source.length && (attribute = getAttribute())) {
			element.properties[attribute.name] = attribute.value;
		}

		var selfClosing = false;

		if (source[i] === '/') {
			i += 1;
			selfClosing = true;
		}

		if (source[i] !== '>') {
			error('Expected >');
		}

		if (!selfClosing) {
			currentElement = element;
			stack.push(element);
		}

		return neutral;
	}

	function comment() {
		var index = source.indexOf('-->', i);
		if (!~index) { error('expected -->'); }

		i = index + 2;
		return neutral;
	}

	function cdata() {
		var index = source.indexOf(']]>', i);
		if (!~index) { error('expected ]]>'); }

		currentElement.children.push(source.slice(i + 7, index));

		i = index + 2;
		return neutral;
	}

	function closingTag() {
		var tagName = getName();

		if (!tagName) { error('Expected tag name'); }

		if (tagName !== currentElement.tagName) {
			error(("Expected closing tag </" + tagName + "> to match opening tag <" + (currentElement.tagName) + ">"));
		}

		allowSpaces();

		if (source[i] !== '>') {
			error('Expected >');
		}

		stack.pop();
		currentElement = stack[stack.length - 1];

		return neutral;
	}

	function getName() {
		var name = '';
		while (i < source.length && validNameCharacters.test(source[i])) { name += source[i++]; }

		return name;
	}

	function getAttribute() {
		if (!whitespace.test(source[i])) { return null; }
		allowSpaces();

		var name = getName();
		if (!name) { return null; }

		var value = true;

		allowSpaces();
		if (source[i] === '=') {
			i += 1;
			allowSpaces();

			value = getAttributeValue();
			if (!isNaN(value) && value.trim() !== '') { value = +value; } // TODO whitelist numeric attributes?
		}

		return { name: name, value: value };
	}

	function getAttributeValue() {
		return quotemark.test(source[i]) ? getQuotedAttributeValue() : getUnquotedAttributeValue();
	}

	function getUnquotedAttributeValue() {
		var value = '';
		do {
			var char = source[i];
			if (char === ' ' || char === '>' || char === '/') {
				return value;
			}

			value += char;
			i += 1;
		} while (i < source.length);

		return value;
	}

	function getQuotedAttributeValue() {
		var quotemark = source[i++];

		var value = '';
		var escaped = false;

		while (i < source.length) {
			var char = source[i++];
			if (char === quotemark && !escaped) {
				return value;
			}

			if (char === '\\' && !escaped) {
				escaped = true;
			}

			value += escaped ? ("\\" + char) : char;
			escaped = false;
		}
	}

	function allowSpaces() {
		while (i < source.length && whitespace.test(source[i])) { i += 1; }
	}

	var i = metadata.length;
	while (i < source.length) {
		if (!state) { error('Unexpected character'); }
		state = state();
		i += 1;
	}

	if (state !== neutral) {
		error('Unexpected end of input');
	}

	if (root.tagName === 'svg') { root.metadata = header; }
	return {
		type: 'root',
		children: [root]
	};
}


//# sourceMappingURL=svg-parser.esm.js.map


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.svg": 49,
	"./10.svg": 50,
	"./11.svg": 51,
	"./12.svg": 52,
	"./13.svg": 53,
	"./14.svg": 54,
	"./15.svg": 55,
	"./16.svg": 56,
	"./17.svg": 57,
	"./18.svg": 58,
	"./19.svg": 59,
	"./2.svg": 60,
	"./20.svg": 61,
	"./21.svg": 62,
	"./22.svg": 63,
	"./23.svg": 64,
	"./24.svg": 65,
	"./25.svg": 66,
	"./26.svg": 67,
	"./27.svg": 68,
	"./28.svg": 69,
	"./29.svg": 70,
	"./3.svg": 71,
	"./30.svg": 72,
	"./31.svg": 73,
	"./32.svg": 74,
	"./33.svg": 75,
	"./34.svg": 76,
	"./35.svg": 77,
	"./36.svg": 78,
	"./37.svg": 79,
	"./38.svg": 80,
	"./39.svg": 81,
	"./4.svg": 82,
	"./40.svg": 83,
	"./41.svg": 84,
	"./42.svg": 85,
	"./5.svg": 86,
	"./6.svg": 87,
	"./7.svg": 88,
	"./8.svg": 89,
	"./9.svg": 90
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48;

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_28_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><circle id=\"XMLID_29_\" class=\"st1\" cx=\"45\" cy=\"19\" r=\"19\"/><circle id=\"XMLID_1_\" class=\"st1\" cx=\"19.3\" cy=\"44.7\" r=\"19\"/></svg>");

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.1 0h63.8v63.8H.1z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M63.9 18.9H32V.1H.1l28.2 28.2C12.4 29.3.1 36.9.1 46.1.1 56 14.4 64 32 64V45.7h31.9V18.9z\"/></svg>");

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.4.8h63.2V64H.4z\"/><path id=\"XMLID_82_\" class=\"st1\" d=\"M.4 0l33.1 32.2-33.1 31z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M32 .5l31.6 15.8L32 32.2z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M32 31.8l31.6-.2L32 63.5z\"/></svg>");

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.2.3h63.7V64H.2z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M63.8 11.7c0 6.5-5.2 11.7-11.7 11.7H11.8C5.3 23.4.1 18.2.1 11.7.2 5.2 5.4 0 11.8 0h40.3c6.5 0 11.7 5.2 11.7 11.7z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M63.8 43.7L32 64 .2 43.7 32 23.4z\"/></svg>");

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.2.3h63.6v63.6H.2z\"/><path id=\"XMLID_82_\" class=\"st1\" d=\"M32 14.9L63.8 0 43.4 32.2z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M63.8 49.1L32 64l11.2-33.7z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M32 .4C14.5.4.2 14.7.2 32.2S14.5 64 32 64V.4z\"/></svg>");

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M64 32c0-12.5-7.2-26.7-17.7-32L32 32l14.3 32C56.8 58.7 64 44.5 64 32z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M0 32C0 19.5 7.2 5.3 17.7 0L32 32 17.7 64C7.2 58.7 0 44.5 0 32z\"/></svg>");

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><circle id=\"XMLID_81_\" class=\"st1\" cx=\"32\" cy=\"32\" r=\"32\"/><circle id=\"XMLID_1_\" class=\"st0\" cx=\"45.2\" cy=\"32\" r=\"6.9\"/></svg>");

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><ellipse id=\"XMLID_83_\" class=\"st1\" cx=\"16.3\" cy=\"32\" rx=\"16\" ry=\"32\"/><ellipse id=\"XMLID_82_\" class=\"st1\" cx=\"48\" cy=\"32\" rx=\"16\" ry=\"32\"/><circle id=\"XMLID_81_\" class=\"st0\" cx=\"21.9\" cy=\"32\" r=\"4.4\"/><circle id=\"XMLID_1_\" class=\"st0\" cx=\"55.1\" cy=\"32\" r=\"4.4\"/></svg>");

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.1 0h64v64H.1z\"/><ellipse id=\"XMLID_83_\" class=\"st1\" cx=\"31.9\" cy=\"47.8\" rx=\"32\" ry=\"16\"/><ellipse id=\"XMLID_82_\" class=\"st1\" cx=\"31.9\" cy=\"16.2\" rx=\"32\" ry=\"16\"/><circle id=\"XMLID_81_\" class=\"st0\" cx=\"49.2\" cy=\"16.2\" r=\"4.4\"/><circle id=\"XMLID_1_\" class=\"st0\" cx=\"49.2\" cy=\"47.5\" r=\"4.4\"/></svg>");

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.2 0h63.7v63.7H.2z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M63.8 37.9S54.3 64 32 64C8.7 64 .2 37.9.2 37.9s9-26.1 31.8-26.1c23.8-.1 31.8 26.1 31.8 26.1z\"/><circle id=\"XMLID_1_\" class=\"st0\" cx=\"17.3\" cy=\"37.7\" r=\"4.3\"/></svg>");

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M0 0h63.9v63.9H0z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M64 47.9H16.1V.1H.1L0 63.9h.1v.1l63.9-.1z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M48.3 16V.1h-16V32H64V16z\"/></svg>");

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_15_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_16_\" class=\"st1\" d=\"M32 16L16 0 0 16v32l16 16 16-16V16z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M64 16L48 0 32 16v32l16 16 16-16V16z\"/></svg>");

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M.2.2h63.5v63.5H.2z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M32 47.6c17.5 0 31.8-10.7 31.8-23.8C63.8 10.7 49.5 0 32 0v47.6z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M.4 48.1H32V64H.4z\"/></svg>");

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M64 16.1C64 7.2 56.8 0 48 0c-8.6 0-15.6 6.8-16 15.4C31.6 6.9 24.6.1 16 .1 7.2.1 0 7.3 0 16.1L32 64l32-47.9z\"/></svg>");

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M.1.2h63.8V64H.1z\"/><g id=\"XMLID_1_\"><path id=\"XMLID_94_\" class=\"st1\" d=\"M50.7 33c5.2 0 9.8 2.1 13.2 5.4V.2l-23 23L32.5 0 .1 29.1l31.3 3.7L.2 64H36c-2.7-3.3-4.3-7.5-4.3-12.1 0-10.5 8.5-18.9 19-18.9z\"/></g></svg>");

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M33.7 0L0 15.3l23 8.5L0 49.7 22.7 64l5.5-27.8 22.3 23.3L45.9 35 64 18.1l-32 5.7z\"/></svg>");

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff;stroke:#231f20;stroke-miterlimit:10}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M22.5 64S0 51.2 0 29.5C0 10 20.1 0 39.5 0c12.7 0 21.4 8.5 21.4 21.5 0 21-25.3 33.7-25.3 33.7L25.4 19.1 22.5 64z\"/></svg>");

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff;stroke:#231f20;stroke-miterlimit:10}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M32 0C20.2 0 0 4.6 0 28s17.8 36 17.8 36V27.8L40 50V27.8h24S61.3 0 32 0z\"/></svg>");

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff;stroke:#231f20;stroke-miterlimit:10}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M0 35.1l24.6-22.2 5.9 31.6L64 3.3v48.8L30.3 59 7.4 36.1 0 64z\"/></svg>");

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M14.5 0C2.9 0 0 32.2 0 44v20h28.9V44c0-11.8-2.4-44-14.4-44z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M46.7 21.5c-14 0-17.5 34.7-17.5 42.5H64c0-7.8-2.7-42.5-17.3-42.5z\"/></svg>");

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><ellipse id=\"XMLID_94_\" class=\"st1\" cx=\"32\" cy=\"49\" rx=\"32\" ry=\"15\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M64 32l-29.6-5.8L0 39.8l20.6-19.5L1.1 0l34.1 11.4L64 0 41.9 19.9z\"/></svg>");

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_95_\" class=\"st1\" d=\"M0 19.9L64 64 14 0H0z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M14 0l50 43.6L39 0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M39 0l25 18V0z\"/></svg>");

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_28_\" class=\"st0\" d=\"M0 0h63.9v63.9H0z\"/><path id=\"XMLID_29_\" class=\"st1\" d=\"M32 63.9c17.6 0 32-14.3 32-32C64 14.3 49.6 0 32 0v63.9z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M0 .1L32 32 0 64z\"/></svg>");

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M.1 0h64v64H.1z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M-.1 24.8L18.8 0l45.3 21.8S32.1 10 32.1 32c0 21.2 31.8 9.7 31.8 9.7L35.3 64 24.5 34.3l-8 29.7S20.1 24.8-.1 24.8z\"/></svg>");

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h63.9v63.9H0z\"/><path id=\"XMLID_95_\" class=\"st1\" d=\"M22.1 63.9c12.2 0 22-14.3 22-32 0-17.6-9.9-32-22-32v64z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M0 .1L22.1 32 0 64z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M54 64l-9.9-32L54 .1 64 32z\"/></svg>");

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h63.9v63.9H0z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M0 31V0h29.4v64C13.1 64 0 49.7 0 32\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M29.4 0l17.3 64L64 0z\"/></svg>");

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M0 0l32 32-23.8 9 29.2 23 21.5-23.9-23.6-13.3L64 0z\"/></svg>");

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><g id=\"XMLID_1_\"><path id=\"XMLID_94_\" class=\"st1\" d=\"M64 32.1V31c-17.1-.3-31-14-31.6-31h-.8C31 17 17.2 30.7 0 30.9V32c17.5.3 31.5 14.5 31.6 32h.8c.1-17.5 14.1-31.7 31.6-31.9z\"/></g></svg>");

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M.1.1H64V64H.1z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M.1 63.8C35.4 63.8 64 49.5 64 31.9 63.9 14.3 35.3 0 .1 0v63.8z\"/></svg>");

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><g id=\"XMLID_1_\"><path id=\"XMLID_94_\" class=\"st1\" d=\"M39.7 24.3H9.1V0H0v64h64v-9.5H39.7z\"/></g></svg>");

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M.1.1H64V64H.1z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M.1 0l30.4 58.6L23.9 0H50L34.4 54.2l29.5-22.3v15.4L30.5 64 .1 36.7z\"/></svg>");

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M0 26.1L33.8 0s10.5-.5 10.5 10.5c0 13.2-20.6 16.8-44.3 15.6z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M36.3 21.1V64L64 38.5z\"/></svg>");

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M0 9c16.2 0 27.7 3.7 23.1 14.7 0 0 12.4-16.1 26-16.1 5.6 0 9.2 4.6 9.2 12.1C58.3 42.5 26.5 64 26.5 64l10.7-30.7L0 42.5V9z\"/></svg>");

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_41_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_42_\" class=\"st1\" d=\"M37 0h27v34.6H37z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M.5 23.9h40v40H.5z\"/></svg>");

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M0 27.8S8.8 0 29.2 0s-2.1 39.7-2.1 39.7L64 0v39.7H39.5s.8 18.8-14 18.8c-14.7 0-8-22.9-8-22.9L0 27.8z\"/></svg>");

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M0 0v27.3L21.1 64S32 51.8 32 32 19.3 0 0 0z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M30.6 32L64 0v64z\"/></svg>");

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_93_\" class=\"st0\" d=\"M0 0h64v64H0z\"/><path id=\"XMLID_94_\" class=\"st1\" d=\"M0 20.2L40.7 0s35.8 12.6 17.8 29.2-58.5-9-58.5-9z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M23.9 32L0 46.5 37 64l26.6-16z\"/></svg>");

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_41_\" class=\"st0\" d=\"M.3.5h63.5V64H.3z\"/><path id=\"XMLID_42_\" class=\"st1\" d=\"M50.4 0l-9.3 23.2L31.8 0l-9.3 23.2L13.2 0 .3 32.3h63z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M50.4 31.5l-9.3 23.2-9.3-23.2-9.3 23.2-9.3-23.2L.3 63.8h63z\"/></svg>");

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_41_\" class=\"st0\" d=\"M-.2 0h64v64h-64z\"/><path id=\"XMLID_43_\" class=\"st1\" d=\"M32.2 0l32 16-32 16.1z\"/><path id=\"XMLID_42_\" class=\"st1\" d=\"M32.2 31.7l32 16-32 16.1z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M-.1 13.3l23.4 9.3L-.1 32l23.4 9.4-23.4 9.3 32.6 13.1V.2z\"/></svg>");

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_41_\" class=\"st0\" d=\"M.1.2h63.8V64H.1z\"/><path id=\"XMLID_42_\" class=\"st1\" d=\"M.1 0C.1 17.6 14.4 31.9 32 31.9c17.6 0 31.9-14.3 31.9-31.9H.1z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M13.3 64l9.4-23.3L32 64l9.3-23.3L50.7 64l13-32.5H.3z\"/></svg>");

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_41_\" class=\"st0\" d=\"M.3.2h63.8V64H.3z\"/><path id=\"XMLID_43_\" class=\"st1\" d=\"M64.2 64c0-9-7.3-16.3-16.3-16.3S31.6 55 31.6 64h32.6z\"/><path id=\"XMLID_42_\" class=\"st1\" d=\"M32.4 64c0-9-7.3-16.3-16.3-16.3S-.2 55-.2 64h32.6z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M51 0l-9.3 23.3L32.3 0 23 23.3 13.7 0 .7 32.5H64z\"/></svg>");

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ("<svg id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"64\" height=\"64\" viewBox=\"0 0 64 64\"><style>.st0{fill:#231f20}.st1{fill:#fff}</style><path id=\"XMLID_80_\" class=\"st0\" d=\"M.1 0h63.8v63.8H.1z\"/><path id=\"XMLID_83_\" class=\"st1\" d=\"M.2 31.7l23-24.8 14.5 24.8z\"/><path id=\"XMLID_82_\" class=\"st1\" d=\"M37.2 31.7L50.7 16l13.4 15.7z\"/><path id=\"XMLID_81_\" class=\"st1\" d=\"M-.1 64l9.9-34.4L19.7 64z\"/><path id=\"XMLID_1_\" class=\"st1\" d=\"M18.9 64l28.8-32.7L64.1 64z\"/></svg>");

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(h) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HallNumber; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_Cell__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_controllers_symbols__ = __webpack_require__(10);










var HallNumber =
/*#__PURE__*/
function (_Cell) {
  __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_inherits___default()(HallNumber, _Cell);

  function HallNumber() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, HallNumber);

    return __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_possibleConstructorReturn___default()(this, __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HallNumber).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(HallNumber, [{
    key: "beforeRender",
    value: function beforeRender(props) {
      __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_get___default()(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_getPrototypeOf___default()(HallNumber.prototype), "beforeRender", this).call(this, props);

      this.props.color = 'black';
      this.props.class = 'is-locked';
    }
  }, {
    key: "afterRender",
    value: function afterRender(props) {
      this.refs.use.remove();
      this.refs.clipPath.remove();

      var style = function style(fs) {
        var fw = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 400;
        return Object.entries({
          'font-family': 'inter',
          'font-size': fs + 'mm',
          'font-weight': fw
        }).map(function (_ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              prop = _ref2[0],
              value = _ref2[1];

          return prop + ':' + value;
        }).join(';');
      };

      var padding = 40;
      this.render([h("text", {
        x: this.state.width - padding,
        y: padding,
        "text-anchor": "end",
        "alignment-baseline": "hanging",
        fill: "white",
        style: style(__WEBPACK_IMPORTED_MODULE_8_controllers_symbols__["a" /* BASE_UNIT */] / 3)
      }, "hall"), h("text", {
        ref: this.ref('number'),
        x: this.state.width - padding,
        y: this.state.height - padding,
        "text-anchor": "end",
        "alignment-baseline": "baseline",
        fill: "white",
        style: style(__WEBPACK_IMPORTED_MODULE_8_controllers_symbols__["a" /* BASE_UNIT */] * 1.6, 600)
      }, props.number)], this.base);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.refs.number.innerHTML = (parseInt(this.refs.number.innerHTML) + 1) % 23;
    }
  }]);

  return HallNumber;
}(__WEBPACK_IMPORTED_MODULE_7_components_Cell__["a" /* default */]);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(0)["h"]))

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(93);

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(3);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_file_saver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_file_saver__);
/* global Blob */

/* harmony default export */ __webpack_exports__["a"] = (function (wall) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Date.now();
  var blob = new Blob([wall.svgString], {
    type: 'image/svg+xml'
  });
  return __WEBPACK_IMPORTED_MODULE_0_file_saver___default.a.saveAs(blob, filename);
});

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(a,b){if(true)!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (b),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));else if("undefined"!=typeof exports)b();else{b(),a.FileSaver={exports:{}}.exports}})(this,function(){"use strict";function b(a,b){return"undefined"==typeof b?b={autoBom:!1}:"object"!=typeof b&&(console.warn("Deprecated: Expected third argument to be a object"),b={autoBom:!b}),b.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(a.type)?new Blob(["\uFEFF",a],{type:a.type}):a}function c(b,c,d){var e=new XMLHttpRequest;e.open("GET",b),e.responseType="blob",e.onload=function(){a(e.response,c,d)},e.onerror=function(){console.error("could not download file")},e.send()}function d(a){var b=new XMLHttpRequest;b.open("HEAD",a,!1);try{b.send()}catch(a){}return 200<=b.status&&299>=b.status}function e(a){try{a.dispatchEvent(new MouseEvent("click"))}catch(c){var b=document.createEvent("MouseEvents");b.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),a.dispatchEvent(b)}}var f="object"==typeof window&&window.window===window?window:"object"==typeof self&&self.self===self?self:"object"==typeof global&&global.global===global?global:void 0,a=f.saveAs||("object"!=typeof window||window!==f?function(){}:"download"in HTMLAnchorElement.prototype?function(b,g,h){var i=f.URL||f.webkitURL,j=document.createElement("a");g=g||b.name||"download",j.download=g,j.rel="noopener","string"==typeof b?(j.href=b,j.origin===location.origin?e(j):d(j.href)?c(b,g,h):e(j,j.target="_blank")):(j.href=i.createObjectURL(b),setTimeout(function(){i.revokeObjectURL(j.href)},4E4),setTimeout(function(){e(j)},0))}:"msSaveOrOpenBlob"in navigator?function(f,g,h){if(g=g||f.name||"download","string"!=typeof f)navigator.msSaveOrOpenBlob(b(f,h),g);else if(d(f))c(f,g,h);else{var i=document.createElement("a");i.href=f,i.target="_blank",setTimeout(function(){e(i)})}}:function(a,b,d,e){if(e=e||open("","_blank"),e&&(e.document.title=e.document.body.innerText="downloading..."),"string"==typeof a)return c(a,b,d);var g="application/octet-stream"===a.type,h=/constructor/i.test(f.HTMLElement)||f.safari,i=/CriOS\/[\d]+/.test(navigator.userAgent);if((i||g&&h)&&"object"==typeof FileReader){var j=new FileReader;j.onloadend=function(){var a=j.result;a=i?a:a.replace(/^data:[^;]*;/,"data:attachment/file;"),e?e.location.href=a:location=a,e=null},j.readAsDataURL(a)}else{var k=f.URL||f.webkitURL,l=k.createObjectURL(a);e?e.location=l:location.href=l,e=null,setTimeout(function(){k.revokeObjectURL(l)},4E4)}});f.saveAs=a.saveAs=a,"undefined"!=typeof module&&(module.exports=a)});

//# sourceMappingURL=FileSaver.min.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(96)))

/***/ }),
/* 96 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// 33c6b94ad53025efb8da.js